// Human readable record numbers shown on screen and on printed documents.

export const formatPatientCode = (sequence: number): string => `DSC-${String(sequence).padStart(4, '0')}`

export const formatPrescriptionNumber = (sequence: number, date: string): string => {
    return `RX-${date.slice(0, 4)}-${String(sequence).padStart(4, '0')}`
}

export const formatInvoiceNumber = (prefix: string, sequence: number, date: string): string => {
    const cleanPrefix = prefix.trim().toUpperCase().replace(/[^A-Z0-9-]/g, '') || 'INV'
    return `${cleanPrefix}-${date.slice(0, 4)}-${String(sequence).padStart(4, '0')}`
}
